import * as tslib_1 from "tslib";
//tslint:disable:unified-signatures
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { NgForageCache } from '@ngforage/ngforage-ng5';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/toPromise';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { of } from 'rxjs/observable/of';
import { defaultFormatterFunction } from './defaultFormatterFunction';
/** @internal */
function makeCacheKey(user, y, m, d) {
    return JSON.stringify({
        d: d,
        m: m,
        user: user,
        y: y ? parseInt(y, 10 /* STD_RADIX */) : undefined
    });
}
/** @internal */
function intifyStr(str) {
    return parseInt(str, 10 /* STD_RADIX */);
}
/** @internal */
function formatRect(rect) {
    var split = rect.date.split('-').map(intifyStr);
    var date = new Date();
    date.setUTCHours(0, 0, 0, 0);
    // tslint:disable-next-line:no-magic-numbers
    date.setUTCFullYear(split[0], split[1] - 1, split[2]);
    return {
        count: rect.count,
        date: date,
        fill: rect.fill
    };
}
/** @internal */
function formatRects(rects) {
    return rects.map(formatRect);
}
/** @internal */
function formatPayload(input) {
    return {
        gs: input.gs.map(formatRects),
        months: input.months
    };
}
/** Fetches and formats the calendar via a CORS proxy */
var CalendarFetcher = (function () {
    function CalendarFetcher(cache, fn, http) {
        this.cache = cache;
        this.fn = fn;
        this.http = http;
        cache.cacheTime = 3600000 /* CACHE_TIME */;
        cache.name = "gh_contrib_calendar" /* STORE_NAME */;
        cache.storeName = "gh_contrib_calendar" /* STORE_NAME */;
        cache.description = "GhContribCalendar store" /* STORE_DESCRIPTION */;
    }
    /** @internal */
    CalendarFetcher.prototype.fetch = function (user, fnOrYear, month, day, possibleFn) {
        var _this = this;
        var fnOrYearIsFunction = typeof fnOrYear === 'function';
        var actualFn = fnOrYearIsFunction ?
            fnOrYear :
            possibleFn || this.fn;
        var actualYear = fnOrYearIsFunction ? undefined : fnOrYear;
        var cacheKey = makeCacheKey(user, actualYear, month, day);
        return fromPromise(this.cache.getCached(cacheKey))
            .switchMap(function (cached) {
            if (cached.hasData && (!cached.expired || navigator.onLine === false)) {
                return of(formatPayload(cached.data));
            }
            var url = actualFn(user, actualYear, month, day);
            var subj = new BehaviorSubject(cached.hasData ? cached.data : null);
            setTimeout(function () {
                _this.http.get(url, {
                    observe: 'body',
                    reportProgress: false,
                    responseType: 'json',
                    withCredentials: false
                })
                    .switchMap(function (v) { return _this.cache.setCached(cacheKey, v); })
                    .toPromise()
                    .then(function (v) {
                    subj.next(v);
                    subj.complete();
                })
                    .catch(function (e) {
                    subj.error(e);
                    subj.complete();
                });
            }, 0);
            return subj.filter(function (v) { return !!v; }).map(formatPayload);
        });
    };
    CalendarFetcher = tslib_1.__decorate([
        Injectable(),
        tslib_1.__param(0, Inject(NgForageCache)),
        tslib_1.__param(1, Inject(defaultFormatterFunction)),
        tslib_1.__param(2, Inject(HttpClient)),
        tslib_1.__metadata("design:paramtypes", [NgForageCache, Function, HttpClient])
    ], CalendarFetcher);
    return CalendarFetcher;
}());
export { CalendarFetcher };



//////////////////
// WEBPACK FOOTER
// ./src/GhContribCalendar/CalendarFetcher/CalendarFetcher.ts
// module id = 23
// module chunks = 0 1